import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useOutletContext } from "react-router";
import BoxLayout from "../../../components/Common/BoxLayout/BoxLayout";
import Button from "../../../components/Common/Button/Button";
import DataTable from "../../../components/Common/DataTable/DataTable";
import AddIcon from "../../../components/Common/SvgIcons/AddIcon";
import { useFetchData } from "../../../hooks/useFetchData";
import { setRolesAndPermissionsAction } from "../../../store/actions/actionCreators/adminActionCreator/rolesAndPermissionsActionCreator";
import {
  getRolesAndPermissionsActionHandler,
  postRoleMenuMappingActionHandler,
} from "../../../store/actions/actionHandlers/adminActionHandler/rolesAndPermissionsActionHandler";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import { rolesAndPermission } from "../../../utils/mainTabs/admin/rolesAndPermissions/rolesAndPermissions";
import { tableColumnTypes } from "../../../utils/tableColumnTypes";
import CreateNewRoleModal from "./CreateNewRole/CreateNewRoleModal";
import classes from "./RolesAndPermissions.module.scss";
import { FormattedMessage } from "react-intl";

const RolesAndPermissions = () => {
  const { setAdminHeader, setAdminNavLinks, setAdminTiles, tenantName } =
    useOutletContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [tableColumns, setTableColumns] = useState([]);
  const { columns } = rolesAndPermission;
  const adminStateReducer = useSelector((state) => state.adminReducer);
  const { rolesAndPermissionsReducer } = adminStateReducer;
  const { rolesAndPermissions, postRoleLoader } = rolesAndPermissionsReducer;
  const { updatedData, setUpdatedData, totalRows, loading, handleSearchQuery } =
    useFetchData(getRolesAndPermissionsActionHandler);
  const [selectedRoleMenu, setSelectedRoleMenu] = useState([]);
  const [addRoleModal, setaddRoleModal] = useState(false);

  useEffect(() => {
    setAdminHeader("");
    setAdminTiles([]);
    setAdminNavLinks(rolesAndPermission.navLinks(navigate, tenantName));
  }, [navigate, setAdminHeader, setAdminNavLinks, setAdminTiles, tenantName]);

  const handleCheckboxChange = useCallback(
    (roleID, permissionID, isMenuselected) => {
      setSelectedRoleMenu([
        ...selectedRoleMenu,
        {
          OStatus: isMenuselected ? true : false,
          PId: permissionID,
          RId: roleID,
        },
      ]);
      const updatedData = rolesAndPermissions?.lstpermissions?.map((data) => {
        if (data?.PermissionId === permissionID) {
          const updatedTemp = data?.lstRoles?.map((role) => {
            if (role?.RoleID === roleID) {
              return {
                ...role,
                IsMenuselected: role?.IsMenuselected === 1 ? 0 : 1,
              };
            } else return role;
          });
          return {
            ...data,
            lstRoles: updatedTemp,
          };
        } else return data;
      });
      dispatch(
        setRolesAndPermissionsAction({
          ...rolesAndPermissions,
          lstpermissions: updatedData,
        })
      );
      setUpdatedData(updatedData);
    },
    [dispatch, rolesAndPermissions, setUpdatedData, selectedRoleMenu]
  );

  const setPermissionName = (name) => {
    switch (name) {
      case "Certificate":
        return <FormattedMessage id="Certificate" />;
      case "Contribute_Content":
        return <FormattedMessage id="Contribute_Content" />;
      case "Create_ShotClass":
        return <FormattedMessage id="Create_ShotClass" />;
      case "Distribute_ShotClass":
        return <FormattedMessage id="Distribute_ShotClass" />;
      case "Edit_ShotClass":
        return <FormattedMessage id="Edit_ShotClass" />;
      case "Email Triggers":
        return <FormattedMessage id="Email Triggers" />;
      case "Forum":
        return <FormattedMessage id="Forum" />;
      case "Learner_Permissions":
        return <FormattedMessage id="Learner_Permissions" />;
      case "Manage Events - Live Quiz":
        return "Manage Events - Live Quiz";
      case "Manage Events - Virtual Quiz":
        return "Manage Events - Virtual Quiz";
      case "Manage Queries For Admins":
        return <FormattedMessage id="Manage Queries For Admins" />;
      case "Manage Queries For Learners":
        return <FormattedMessage id="Manage Queries For Learners" />;
      case "Manage_Roles":
        return <FormattedMessage id="Manage_Roles" />;
      case "Mobile_Permissions":
        return <FormattedMessage id="Mobile_Permissions" />;
      case "Moderate_Shotclasses":
        return <FormattedMessage id="Moderate_Shotclasses" />;
      case "NOTIFICATION_MANAGEMENT":
        return <FormattedMessage id="NOTIFICATION_MANAGEMENT" />;
      case "Password_Expiry":
        return "Password_Expiry";
      case "Poll_Management":
        return <FormattedMessage id="Poll_Management" />;
      case "Report_ShotClass":
        return <FormattedMessage id="Report_ShotClass" />;
      case "Topic_Management":
        return <FormattedMessage id="TOPICMANAGEMENT_TEXT" />;
      case "View_Roles":
        return <FormattedMessage id="View_Roles" />;
      case "Web_Learning":
        return <FormattedMessage id="Web_Learning" />;
      case "UserGroup_Management":
        return <FormattedMessage id="USERGROUP_MAINHEADER" />;
      default:
        return;
    }
  };

  useEffect(() => {
    const colArr = {
      ID: 1,
      name: <FormattedMessage id="PERMISSION_TXT" />,
      fieldName: "PermissionName",
      value: (row) => {
        return setPermissionName(row?.PermissionKey);
      },
      sort: false,
      type: tableColumnTypes.STRING,
    };
    let newTableColumns = columns(
      rolesAndPermissions?.lstRoles,
      handleCheckboxChange
    );
    if (newTableColumns) setTableColumns([colArr, ...newTableColumns]);
  }, [columns, rolesAndPermissions, handleCheckboxChange]);

  const onSubmit = () => {
    if (selectedRoleMenu?.length > 0)
      dispatch(
        postRoleMenuMappingActionHandler(selectedRoleMenu, handleSearchQuery)
      );
    else
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          "Please Select Some Permission for Some Role"
        )
      );
    setSelectedRoleMenu([]);
  };
  return (
    <>
      <div className={classes.rolesAndPermission}>
        <div className={classes.addRole}>
          <p
            className={
              !rolesAndPermissions || rolesAndPermissions?.IsCurrentUserAdmin
                ? classes.disabledText
                : classes.text
            }
            onClick={() => {
              if (
                !rolesAndPermissions?.IsCurrentUserAdmin &&
                rolesAndPermissions
              )
                setaddRoleModal(true);
            }}
          >
            <AddIcon
            fill={
              !rolesAndPermissions || rolesAndPermissions?.IsCurrentUserAdmin
                ? "#b9b9b9"
                : colors.theme
            }
          />&nbsp;
            Add New Role
          </p>
        </div>
        <BoxLayout padding={[0, 0, 0, 0]}>
          <DataTable
            columns={tableColumns ? tableColumns : []}
            data={updatedData}
            setData={setUpdatedData}
            totalRows={totalRows}
            loading={loading}
            uniqueFieldName={"PermissionId"}
            isFooter={false}
          />
          <div className={classes.saveBtn}>
            <span
              className={
                !rolesAndPermissions ||
                rolesAndPermissions?.IsCurrentUserAdmin ||
                selectedRoleMenu?.length === 0
                  ? classes.disabledText
                  : classes.text
              }
              onClick={() => {
                if (
                  selectedRoleMenu?.length > 0 &&
                  !rolesAndPermissions?.IsCurrentUserAdmin
                ) {
                  setSelectedRoleMenu([]);
                  handleSearchQuery();
                }
              }}
            >
              <FormattedMessage id="RESET_MSG" />
            </span>
            <Button
              type="submit"
              label={<FormattedMessage id="SAVE_TXT" />}
              small
              dark
              backgroundColor={postRoleLoader ? undefined : "#D31B61"}
              loading={postRoleLoader}
              disabled={
                !rolesAndPermissions || rolesAndPermissions?.IsCurrentUserAdmin
                  ? true
                  : false
              }
              onClick={onSubmit}
            />
          </div>
        </BoxLayout>
      </div>
      <CreateNewRoleModal
        addRoleModal={addRoleModal}
        setaddRoleModal={setaddRoleModal}
        handleSearchQuery={handleSearchQuery}
      />
    </>
  );
};

export default RolesAndPermissions;
